import PlanSwitcher, { type PlanSwitcherData } from './PlanSwitcher'
import PeriodPicker from './PeriodPicker'
import { formatStatDate } from './HeaderStat'
import { plan_top_down_path } from '@/lib/routes'
import { useMarket } from '@/lib/useMarket'

// The row above the overall editor: plan switcher, the step hint, the
// comparison period picker. Moved out of Edit.tsx to keep that file focused.
export default function EditToolbar({ slug, planId, beginDate, endDate, period, planSwitcher, periodLabels }: {
  slug: string; planId: string; beginDate: string; endDate: string
  period: { start: string; end: string }; planSwitcher: PlanSwitcherData
  // Set only for a quarterly revision: the months already actual vs. the
  // months still being planned.
  periodLabels?: { actual: string; plan: string; months: number } | null
}) {
  const market = useMarket()
  return (
    <div className="mb-4 flex items-center justify-between gap-4 flex-wrap">
      <div style={{ background: 'var(--background)', borderColor: 'var(--border)' }} className="border rounded-lg px-4 py-2.5">
        <PlanSwitcher data={planSwitcher} />
      </div>
      <div className="min-w-0 flex-1 rounded-lg border border-primary/20 bg-primary/5 px-4 py-2.5 text-sm leading-relaxed text-foreground">
        {periodLabels ? (
          <>
            Revise the remaining months ({periodLabels.plan}). The first {periodLabels.months} months are actual
            sales and are shown next to each target.
          </>
        ) : (
          <>
            Add product groups you plan to sell in {market.name} from {formatStatDate(beginDate)} – {formatStatDate(endDate)},
            then set the target revenue for them.<br />
            After finishing, hit Complete button to move to step 2 (Channel Breakdown).
          </>
        )}
      </div>
      <div style={{ background: 'var(--background)', borderColor: 'var(--border)' }} className="border rounded-lg px-4 py-2.5 ml-auto">
        <PeriodPicker planId={planId} beginDate={beginDate} endDate={endDate} start={period.start} end={period.end}
          path={plan_top_down_path(market.slug, slug)} only={['node_revenue', 'period', 'plan_nodes']} />
      </div>
    </div>
  )
}
